module.exports = __webpack_public_path__ + "img/logo-1-zh.0038aca6.png";